module.exports = __webpack_public_path__ + "static/img/tilogo.71fa019.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/tilogo.png
// module id = Tpge
// module chunks = 1